import { IntegrationAccount } from "./integrationAccount";
import { User } from "./user";

export enum ConnectionProvider {
    PAYPAL = "PayPal",
}

export interface IntegrationConnection {
    id: string;
    provider: ConnectionProvider;
    providerId: string | null;
    label: string | null;
    workspaceId: string;
    createdByUser?: User | null;
    createdByUserId: number | null;
    createdAt: Date;
    institutionLogoUrl: string | null;
    institutionName: string | null;
    metadata: any;
    error: string | null;
    integrationAccounts?: IntegrationAccount[];
}
